export enum DxCodeConfigTab {
  REGIMEN = "regimen",
  DRUG = "drug",
}
